export const LIMITE_CUENTA_CORRIENTE_FALLBACK = 130000;

export const PROPORCION_UMBRAL_WARNING = 0.7;
export const PROPORCION_UMBRAL_ERROR = 0.8;
export const PROPORCION_UMBRAL_ERROR_CRITICO = 0.95;

const roundMoney = (value) => Number(Number(value || 0).toFixed(2));

const positiveNumberOr = (value, fallback) => {
	const parsed = Number(value);
	return Number.isFinite(parsed) && parsed > 0 ? parsed : fallback;
};

export const resolveCuentaCorrienteConfig = (resumen = null) => {
	const limiteCuentaCorriente = positiveNumberOr(
		resumen?.limiteCuentaCorriente,
		LIMITE_CUENTA_CORRIENTE_FALLBACK
	);

	return {
		limiteCuentaCorriente,
		umbralWarning: positiveNumberOr(
			resumen?.umbralWarning,
			roundMoney(limiteCuentaCorriente * PROPORCION_UMBRAL_WARNING)
		),
		umbralError: positiveNumberOr(
			resumen?.umbralError,
			roundMoney(limiteCuentaCorriente * PROPORCION_UMBRAL_ERROR)
		),
		umbralErrorCritico: positiveNumberOr(
			resumen?.umbralErrorCritico,
			roundMoney(limiteCuentaCorriente * PROPORCION_UMBRAL_ERROR_CRITICO)
		),
	};
};
